module.exports = __webpack_public_path__ + "assets/arrow_right.6abf3845.svg";